
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.707 3.879A3 3 0 017.828 3c.79 0 1.948-.22 2.302.711a2.001 2.001 0 003.74 0c.354-.93 1.513-.71 2.302-.71a3 3 0 012.12.878L22 7.586a2 2 0 010 2.828l-1.478 1.478c-.52.52-1.246.689-1.9.526l.272 5.432A3 3 0 0115.898 21H8.102a3.001 3.001 0 01-2.996-3.15l.272-5.432a1.996 1.996 0 01-1.9-.526L2 10.414a2 2 0 010-2.828l3.707-3.707z","fill":"#fff"}})])
          )
        }
      }
    